var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilverGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 56,
    viewBox: "0 0 115 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 19.5063C14.3212 21.6434 8.76033 20.2884 6.51837 19.3437L6.51837 40.1174L108.048 40.1174L108.048 15.7706C102.703 20.8536 98.8927 18.9646 94.3634 17.4423C84.5467 15.0788 79.7646 21.0533 72.9026 22.0464C66.0406 23.0395 61.2198 21.1501 56.71 16.7443C52.2002 12.3385 47.1266 12.4936 42.5389 16.8954C37.9513 21.2972 34.4523 19.6181 31.2059 18.6205C27.9596 17.623 24.0135 16.8349 18.6289 19.5063Z",
    fill: "url(#paint0_linear_31_14152)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 19.5063C14.3212 21.6434 8.76033 20.2884 6.51837 19.3437L6.51837 40.1174L108.048 40.1174L108.048 15.7706C102.703 20.8536 98.8927 18.9646 94.3634 17.4423C84.5467 15.0788 79.7646 21.0533 72.9026 22.0464C66.0406 23.0395 61.2198 21.1501 56.71 16.7443C52.2002 12.3385 47.1266 12.4936 42.5389 16.8954C37.9513 21.2972 34.4523 19.6181 31.2059 18.6205C27.9596 17.623 24.0135 16.8349 18.6289 19.5063Z",
    fill: "url(#paint1_linear_31_14152)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 19.5063C14.3212 21.6434 8.76033 20.2884 6.51837 19.3437L6.51837 40.1174L108.048 40.1174L108.048 15.7706C102.703 20.8536 98.8927 18.9646 94.3634 17.4423C84.5467 15.0788 79.7646 21.0533 72.9026 22.0464C66.0406 23.0395 61.2198 21.1501 56.71 16.7443C52.2002 12.3385 47.1266 12.4936 42.5389 16.8954C37.9513 21.2972 34.4523 19.6181 31.2059 18.6205C27.9596 17.623 24.0135 16.8349 18.6289 19.5063Z",
    fill: "url(#paint2_linear_31_14152)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 19.5063C14.3212 21.6434 8.76033 20.2884 6.51837 19.3437L6.51837 40.1174L108.048 40.1174L108.048 15.7706C102.703 20.8536 98.8927 18.9646 94.3634 17.4423C84.5467 15.0788 79.7646 21.0533 72.9026 22.0464C66.0406 23.0395 61.2198 21.1501 56.71 16.7443C52.2002 12.3385 47.1266 12.4936 42.5389 16.8954C37.9513 21.2972 34.4523 19.6181 31.2059 18.6205C27.9596 17.623 24.0135 16.8349 18.6289 19.5063Z",
    fill: "url(#paint3_linear_31_14152)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 19.5063C14.3212 21.6434 8.76033 20.2884 6.51837 19.3437L6.51837 40.1174L108.048 40.1174L108.048 15.7706C102.703 20.8536 98.8927 18.9646 94.3634 17.4423C84.5467 15.0788 79.7646 21.0533 72.9026 22.0464C66.0406 23.0395 61.2198 21.1501 56.71 16.7443C52.2002 12.3385 47.1266 12.4936 42.5389 16.8954C37.9513 21.2972 34.4523 19.6181 31.2059 18.6205C27.9596 17.623 24.0135 16.8349 18.6289 19.5063Z",
    fill: "url(#paint4_linear_31_14152)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 19.5063C14.3212 21.6434 8.76033 20.2884 6.51837 19.3437L6.51837 40.1174L108.048 40.1174L108.048 15.7706C102.703 20.8536 98.8927 18.9646 94.3634 17.4423C84.5467 15.0788 79.7646 21.0533 72.9026 22.0464C66.0406 23.0395 61.2198 21.1501 56.71 16.7443C52.2002 12.3385 47.1266 12.4936 42.5389 16.8954C37.9513 21.2972 34.4523 19.6181 31.2059 18.6205C27.9596 17.623 24.0135 16.8349 18.6289 19.5063Z",
    fill: "url(#paint5_linear_31_14152)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 19.5063C14.3212 21.6434 8.76033 20.2884 6.51837 19.3437L6.51837 40.1174L108.048 40.1174L108.048 15.7706C102.703 20.8536 98.8927 18.9646 94.3634 17.4423C84.5467 15.0788 79.7646 21.0533 72.9026 22.0464C66.0406 23.0395 61.2198 21.1501 56.71 16.7443C52.2002 12.3385 47.1266 12.4936 42.5389 16.8954C37.9513 21.2972 34.4523 19.6181 31.2059 18.6205C27.9596 17.623 24.0135 16.8349 18.6289 19.5063Z",
    fill: "url(#paint6_linear_31_14152)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31_14152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51892 19.3438C8.76088 20.2885 14.3217 21.6435 18.6294 19.5064C24.0141 16.835 27.9602 17.6231 31.2065 18.6206C34.4528 19.6181 37.9518 21.2973 42.5395 16.8955C47.1271 12.4937 52.2007 12.3386 56.7105 16.7444C61.2203 21.1502 66.0412 23.0396 72.9032 22.0465C79.7652 21.0534 84.5472 15.0789 94.3639 17.4424C98.8932 18.9647 102.703 20.8537 108.049 15.7707",
    stroke: "#ACACAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31_14152",
    x: 0.0253906,
    y: 10.0088,
    width: 114.516,
    height: 21.8037,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.125 0 0 0 0 0.0192708 0 0 0 0 0.0192708 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_14152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_14152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_14152",
    x1: 51.5912,
    y1: 38.0565,
    x2: 51.5912,
    y2: 14.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACACAC",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_14152",
    x1: 51.5912,
    y1: 38.0565,
    x2: 51.5912,
    y2: 14.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACACAC",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_14152",
    x1: 51.5912,
    y1: 38.0565,
    x2: 51.5912,
    y2: 14.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACACAC",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31_14152",
    x1: 51.5912,
    y1: 38.0565,
    x2: 51.5912,
    y2: 14.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACACAC",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_31_14152",
    x1: 51.5912,
    y1: 38.0565,
    x2: 51.5912,
    y2: 14.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACACAC",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_31_14152",
    x1: 51.5912,
    y1: 38.0565,
    x2: 51.5912,
    y2: 14.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACACAC",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_31_14152",
    x1: 51.5912,
    y1: 38.0565,
    x2: 51.5912,
    y2: 14.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACACAC",
    stopOpacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverGraph);
export default __webpack_public_path__ + "static/media/silver-graph.e2c795ced710d9fcf2596b837ffbcb36.svg";
export { ForwardRef as ReactComponent };